define(function (require) {
  var Forms = require('app/modules/forms');
  var FIELDS = ['industries', 'job_functions', 'title', 'location', 'start', 'end', 'is_current_job', 'description', 'main_theme_id', 'sub_themes', 'focuses'];

  var getInputName = function(name, model_name){
    if(!model_name){
      model_name = 'job_application';
    }

    var input_name = model_name + '[experiences_attributes][]['+name+']';
    return (name == 'job_functions' || name == 'industries' || name == 'sub_themes' || name == 'focuses') ? input_name + '[]' : input_name;
  };

  var getInputsData = function(container){
    var result = {};

    FIELDS.forEach(function(field_name) {
      var field = container.find('#experience-' + field_name);

      if(field.attr('type') !== 'checkbox'){
        result[field_name] = field.val();
      } else {
        result[field_name] = field.is(':checked');
      }
    });

    return result;
  };

  var clearFields = function(fields){
    fields.find('input, textarea').not('.checkbox-icheck').val('');
    fields.find('select').val([]).trigger("chosen:updated");
    fields.find('.checkbox-icheck').iCheck('uncheck');
    if ($(".chosen-results").css("overflow") == "auto") {
      $(".chosen-results").css("overflow", "hidden");
    } else {
      $(".chosen-results").css("overflow", "auto");
    }
  };

  var addHtml = function(data, beforeElement, model_name, clean){
    if(data.title && data.start && data.job_functions && data.industries){
      var _template = $('li.education-fields.experience.clearfix.dn');
      var template = _template.clone();
      template.removeClass('dn');
      template.find('.range').html(data.start+' &mdash; '+data.end);
      template.find('.object-name').prepend(data.title);

      if(data.id){
        template.find('.remove-experience').attr('data-url', '/experiences/'+data.id);
        template.find('input').remove();
      } else {
        FIELDS.forEach(function(field_name) {
          var field_data = data[field_name];
          var template_field = template.find('input[name=' + field_name + ']');

          if(Object.prototype.toString.call(field_data) === '[object Array]') {
            field_data.forEach(function(field_data_el) {
              var template_field_clone = template_field.clone();
              template_field_clone.attr({
                name: getInputName(field_name, model_name),
                value: field_data_el
              });
              template_field_clone.insertBefore(template_field);
            });
          } else {
            template_field.attr({
              name: getInputName(field_name, model_name),
              value: field_data
            });
          }
        });
      }

      if (!clean) {
        clearFields(beforeElement);
      }
      template.insertBefore(beforeElement);
    }
  };

  var add = function (link, model_name) {
    var container = $('.education-fields.experience-new');
    var user_inputs = getInputsData(container);

    if(link){
      var section = link.parents('.section-education');

      $.ajax({
        type: 'POST',
        url: link.attr('data-url'),
        data: { experience: user_inputs },
        success: function(result){
          Forms.hideErrors(section);

          if(result.errors_html){
            Forms.showErrors(section, [], '', result.errors_html);
          } else {
            var experience = $.parseJSON(result.experience);
            addHtml({ id: experience.id,
                      title: experience.title,
                      start: experience.date_start,
                      end: experience.date_end,
                      job_functions: experience.job_functions,
                      industries: experience.industries
                    }, container, model_name);
          }
        }
      });
    } else {
      addHtml(user_inputs, container, model_name);
    }
  };

  var remove = function(link){
    var url = link.attr('data-url');

    if(url){
      $.ajax({
        type: 'DELETE',
        url: url,
        success: function(result){
          if(result.status == 'ok'){
            link.parents('li.education-fields').remove();
          }
        }
      });
    } else {
      var parent = link.parents('li.education-fields');
      var destroy = parent.find('[name*=_destroy]');
      if(destroy.length) {
        parent.addClass('dn');
        destroy.val(true);
      }else{
        parent.remove();
      }
    }
  };

  return {
    add: add,
    remove: remove,
    addHtml: addHtml
  };
});
